<template>
  <div>
    <!-- 一键付款弹框 -->
    <el-dialog title="付款" :visible="fuKuanMark" :close-on-click-modal="false" width="600px" center @close="closeDialog">
      <div class="addressBox">
        <div style="width:80%;margin:0 auto;">
          <el-form :inline="true" :rules="rules" :model="dataFrom" ref="dataFrom" class="demo-form-inline" label-width="130px" size="small">
            <el-form-item label="付款金额:">
              <span style="color:red;font-size:18px;margin-right:5px;">{{fuKuanFrom.collectionAmount}}</span><span>元</span>
            </el-form-item>
            <el-form-item label="付款时间:" prop="collectionTime">
              <el-date-picker
                v-model="dataFrom.collectionTime"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择日期时间">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="付款凭证:" v-if="fuKuanMark" class="is-required">
              <uploadImgs4 :imgList.sync='imgList' style="margin-top:5px;" @remove='remove'>
                 <i class="el-icon-upload"></i>
                 <div>将文件拖到此处，或<em>点击上传</em></div>
              </uploadImgs4>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">取 消</el-button>
        <el-button type="primary" @click="fuKuanSubmitFn('dataFrom')">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { wayPaymentForYf, allPaymentForYf } from '@/api/newTMS'
import uploadImgs4 from '@/components/uploadImgs4.vue'
export default {
  components: {
    uploadImgs4
  },
  props: {
    fuKuanMark: {
      type: Boolean,
      default: false
    },
    fuKuanFrom: {
      type: Object,
      default: function () {
        return {}
      }
    },
    detilsFlag: {
      type: Boolean,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      imgList: [],
      dataFrom: {},
      rules: {
        collectionTime: [
          { required: true, message: '请选择付款时间', trigger: 'blur' }
        ]
      }
    }
  },
  mounted () {
    console.log(this.fuKuanFrom, 'this.fuKuanFrom')
  },
  methods: {
    // 删除图片
    remove (file) {
      console.log(file, 'file')
    },
    closeDialog () {
      this.$emit('update:fuKuanMark', false)
      this.$refs.dataFrom.resetFields()
    },
    fuKuanSubmitFn (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.imgList.length == 0 || this.imgList[0] == null) {
            this.$message({
              message: '付款凭证不能为空',
              type: 'error'
            })
            return
          }
          let imgfile = new FormData()
          if (this.imgList.length > 0) {
            imgfile.set('files', this.imgList[0].raw)
          }
          this.$set(this.fuKuanFrom, 'collectionTime', this.dataFrom.collectionTime)
          imgfile.set('params', JSON.stringify(this.fuKuanFrom))
          console.log(this.fuKuanFrom, 'fuKuanFrom')
          if (this.detilsFlag) {
            this.wayPaymentYf(imgfile)
          } else {
            this.allPaymentYf(imgfile)
          }
        } else {
          return false
        }
      })
    },
    // 账单页面一键付款
    allPaymentYf (imgfile) {
      const loading = this.$loading({
        lock: true,
        text: '正在处理...'
      })
      allPaymentForYf(imgfile).then(res => {
        loading.close()
        this.$message({
          message: '成功',
          type: 'success'
        })
        this.$emit('update:fuKuanMark', false)
        this.$emit('refresh')
        this.$refs.dataFrom.resetFields()
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
            loading.close()
          }
        })
      })
    },
    // 账单详情点击收款按钮
    wayPaymentYf (imgfile) {
      const loading = this.$loading({
        lock: true,
        text: '正在处理...'
      })
      wayPaymentForYf(imgfile).then(res => {
        loading.close()
        this.$message({
          message: '成功',
          type: 'success'
        })
        this.$emit('update:fuKuanMark', false)
        this.$emit('refresh')
        this.$refs.dataFrom.resetFields()
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
            loading.close()
          }
        })
      })
    }
  }
}
</script>
<style scoped>
/deep/.el-upload--picture-card{
  background-image:none;
  height: 200px;
  width: 200px!important;
}

</style>
